import { Controller } from "@hotwired/stimulus"

// Removes the element after `after-value` milliseconds. Used by the drilldown
// "still being prepared" notice so it self-clears without requiring user action.
export default class extends Controller {
  static values = { after: { type: Number, default: 3000 } }

  connect() {
    this.timeout = setTimeout(() => this.element.remove(), this.afterValue)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }
}
